import { UsePaymentsModalButtonReturnType } from '../../../hooks';
import { MultiCollectSelectInvoiceModal } from './multi-collect-select-invoice-modal';
import { SelectInvoiceModalCommonProps } from './single-processor-select-invoice-modal';

export type MessagingSelectInvoiceModalProps = SelectInvoiceModalCommonProps & {
  Tooltip: UsePaymentsModalButtonReturnType['Tooltip'];
};

export const MessagingSelectInvoiceModal = ({ Tooltip, ...rest }: MessagingSelectInvoiceModalProps) => {
  return (
    <>
      <MultiCollectSelectInvoiceModal {...rest} />
      {Tooltip}
    </>
  );
};
